import { render, staticRenderFns } from "./HomeApplyFszyy.vue?vue&type=template&id=227d81a4&scoped=true"
import script from "./HomeApplyFszyy.vue?vue&type=script&lang=js"
export * from "./HomeApplyFszyy.vue?vue&type=script&lang=js"
import style0 from "./HomeApplyFszyy.vue?vue&type=style&index=0&id=227d81a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d81a4",
  null
  
)

export default component.exports